<template>
    <ac-modal :title="'Nacha Line Item'" :size-class="'modal-lg'" ref="modal">
        <template v-if="widgetReady">
            <div v-if="isExisting" class="row">
                <div class="col-sm-12 form-group">
                    <label>Choose Payee</label>
                    <select class="form-control" v-model="payeeChange">
                        <!--<option selected value=>Select Payee</option>-->
                        <option v-for="p in existingPayees" :value="p">
                            {{ p.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" v-model="vm.payee.name">
                </div>
                <div class="col-sm-6 form-group">
                    <label>Amount</label>
                    <input type="text" class="form-control" v-model="vm.amount">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 form-group">
                    <label>Type</label>
                    <select v-model="transactionType" class="form-control">
                        <option :value="0" disabled>
                            Select One
                        </option>
                        <option :value="1">
                            PULL
                        </option>
                        <option :value="2">
                            PUSH
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 form-group">
                    <label>Reason</label>
                    <textarea class="form-control form-long-field" rows="2" v-model="vm.reason"></textarea>
                </div>
            </div>
            <ac-banking-info :show-required="true" :save-banking-info="() => {}" :canSave="false" v-model="vm.payee.bankingInfo" :disableControls="isExisting" :key="componentKey">

            </ac-banking-info>
            <div class="row">
                <div class="col-md-12" style="text-align: right;">                    
                    <ac-button :action="save" class="btn btn-green btn-sm pull-right">
                        SAVE
                    </ac-button>
                    <ac-button :action="closeModal" class="btn btn-red btn-sm pull-right" style="margin-right: 5px;">
                        CANCEL
                    </ac-button>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>

    import {notifications} from "../../../../global/notifications.js";
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";
    import AcBankingInfo from '../../../../global/customHtmlElements/AcBankingInfo.vue';

    export default {
        name: "NachaGeneratorPayeeModal",
        data() {
            return {
                widgetReady: false,
                vm: {},
                existingPayees: [],
                payeeChange: null,
                componentKey: 0,
                isExisting: false,
                transactionType: 0
            }
        },        
        watch: {
            payeeChange(newValue, oldValue) {
                this.widgetReady = false;
                this.vm.payee = newValue;
                this.vm.payeeId = newValue.payeeId;
                this.componentKey++;
                this.widgetReady = true;
            }, 
            deep: true
        },
        methods: {
            async showModal(existing) {
                this.widgetReady = false;

                this.isExisting = existing;
                this.existingPayees = await api.getNoId('GeneratedNacha', 'GetGenNachaPayees');
                let template = await api.getNoId('GeneratedNacha', 'GetGeneratedPayeeTemplate');
                this.mapData('vm', template);

                this.widgetReady = true;
                this.$refs.modal.open();
            },
            closeModal() {
                this.$refs.modal.close();
            },
            async save(){
                if (this.vm.name === '') {
                    notifications.showError({ message: "No entity name specified.", title: "Error" });
                    return;
                }
                if (isNaN(this.vm.amount)){
                    notifications.showError({ message: "Amount is not a valid number.", title: "Error" });
                    return;
                }
                if (this.vm.amount <= 0) {
                    notifications.showError({ message: "Amount must be greater than zero.", title: "Error" });
                    return;
                }
                if (this.vm.reason === '' || this.vm.reason === null) {
                    notifications.showError({ message: "Please provide a reason.", title: "Error" });
                    return;
                }
                if(this.transactionType === 0){
                    notifications.showError({ message: "Please select a transaction type.", title: "Error"})
                    return;
                }               

                let validation = await api.post('GeneratedNacha', 'ValidatePayee', this.vm.payee, true);
                
                if (validation) {
                    this.vm.type = this.transactionType === 2 ? "Push" : "Pull"
                    //user can only enter positive amounts but a push transaction means it's being taken out of our account
                    if(this.transactionType === 2) {this.vm.amount = -this.vm.amount}
                    this.$emit("nachaRowSaved", this.vm);
                    this.closeModal();
                }
            }
        }
    }
</script>

<style scoped>

</style>